<template>
  <SettingsPageLayout>
    <Card class="w-11/12 max-w-3xl mx-auto text-center py-24">
      <CardHeader>
        <CardTitle class="text-2xl">Recruiting Landing Pages</CardTitle>
      </CardHeader>
      <CardContent>
        <p class="text-gray-600 mt-2">
          Humaniz landing pages give you another avenue to recruit the perfect candidates. Not every top performer is
          actively looking at job posts, but you can use a Humaniz landing page to share on social media, business
          cards, and more.
        </p>
        <div class="mt-12 flex justify-center items-center gap-5">
          <button
            class="relative flex items-center rounded bg-[#fde68a] px-3 py-2 text-sm font-semibold text-slate-900 ring-1 ring-inset ring-[#fde68a] hover:bg-[#f7d286] focus:z-10"
            @click="createSite"
          >
            Create your landing page
          </button>
          <a
            href="https://www.joinhumaniz.com"
            target="_blank"
            class="text-sm text-indigo-600 hover:text-indigo-900"
            data-track="clicked-view-landing-page-demo"
            >View demo</a
          >
        </div>
      </CardContent>
    </Card>
  </SettingsPageLayout>
</template>

<script>
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import SettingsPageLayout from '../../layouts/SettingsPageLayout/index.vue';
import { toast } from 'vue-sonner';

export default {
  components: {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
    SettingsPageLayout,
  },
  methods: {
    async createSite() {
      const res = await fetch('/api/site_pages', {
        method: 'POST',
        headers: {
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      });

      const data = await res.json();

      if (data.status === 'success') {
        await this.$router.push('/settings/company/landing_pages');
      } else {
        toast.error('Landing page error', {
          action: { label: 'Dismiss' },
          description: data.message,
        });
      }
    },
  },
};
</script>
